// Tiny analytics helper — fires GA4 events, Google Ads conversions, and Meta Pixel
// on key conversion actions. Safe no-op when scripts aren't present.
//
// Google Ads conversion firing:
//   The base gtag.js (in /public/index.html) is configured with both 'G-VN6KJ01LY4' (GA4)
//   and 'AW-17710948645' (Google Ads). When you create a Conversion Action in Google Ads
//   (Tools & Settings → Conversions → "+ New conversion action" → Website → category
//   "Submit lead form"), Google Ads gives you a SEND_TO label like 'AW-17710948645/AbC1xYz'.
//   Paste that label into the GOOGLE_ADS_CONVERSION_LABEL constant below and every lead
//   will be counted as a Google Ads conversion automatically.

// Replace with the SEND_TO label from your Google Ads Conversion Action setup.
// e.g. "AW-17710948645/AbC1xYz". Set to the live value below — every WhatsApp click
// + every lead form submit will count as a Google Ads conversion automatically.
const GOOGLE_ADS_CONVERSION_LABEL = "AW-17710948645/pdKsCOODgLocEKXCnv1B";

// Dedicated Google Ads Conversion Action for the /honeymoon-experiences campaign
// (higher value proxy — HNW couples). Paste the SEND_TO label Google Ads gives you
// for the "Luxury Honeymoon Lead" Conversion Action here. Format:
// "AW-17710948645/YOUR_LUXURY_LABEL".
// If left blank, luxury leads still count under the default conversion action above.
const LUXURY_HONEYMOON_CONVERSION_LABEL = ""; // e.g. "AW-17710948645/AbC-lux99"

const isProd = typeof window !== "undefined";

export function trackLead({
  source = "unknown",      // "whatsapp_btn" | "lp_form" | "package_send" | "footer_whatsapp" ...
  destination = null,
  value = 2000,            // INR proxy value for a captured lead
  label = "vacationspro_lead",
  conversionLabel = null,  // override — pass a Google Ads SEND_TO to fire a distinct Conversion Action
  extra = {},
} = {}) {
  if (!isProd) return;
  // Route to luxury-specific Conversion Action when the caller asks for it, or when
  // the label/source hints at a luxury honeymoon lead. Keeps ads reporting clean.
  const isLuxury =
    label === "luxury_honeymoon_lead" ||
    (typeof source === "string" && source.startsWith("lp_lux"));
  const sendTo = conversionLabel
    || (isLuxury && LUXURY_HONEYMOON_CONVERSION_LABEL)
    || GOOGLE_ADS_CONVERSION_LABEL;
  try {
    if (typeof window.gtag === "function") {
      // 1) Generic GA4 lead event — feeds Analytics, Audiences, Recommendations.
      window.gtag("event", "generate_lead", {
        currency: "INR",
        value,
        event_label: label,
        lead_source: source,
        destination: destination || undefined,
        ...extra,
      });
      // 2) Google Ads conversion — routes to the appropriate Conversion Action.
      if (sendTo) {
        window.gtag("event", "conversion", {
          send_to: sendTo,
          value,
          currency: "INR",
          transaction_id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        });
      }
    }
  } catch (e) {
    console.warn("gtag generate_lead failed", e);
  }
  try {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        content_category: source,
        destination: destination || undefined,
      });
    }
  } catch (e) {
    console.warn("fbq Lead failed", e);
  }
}

// Generic page-level event (e.g. spotlight_open, package_drafted)
export function trackEvent(name, params = {}) {
  if (!isProd) return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) { console.warn("gtag event failed", name, e); }
}
